import { EventUtils } from "../../../../application/EventUtils";
import { Label3D } from '../../../../gui/Label3D';
import { HUDLabel, LABEL_ANCHORING } from '../../HudLabel';
import LayerBackButton from "../LayerBackButton";
import { FacetTypes } from "../../../facets/Facets";

const INVALID_POS3D = { x: Infinity, y: Infinity, z: Infinity };

export class LevelLabel {

  constructor(level, name, hud) {
    this.level = level;
    this.name = name;
    this.label = this.#makeLabel(hud);
    this.isSelected = false;
    this.#setAnchor(LABEL_ANCHORING.END);
  }

  dispose() {
    this.label.clearListeners();
    this.label.dtor();
  }

  getPosition3D() {
    return this.label.pos3D;
  }

  isVisible() {
    return this.label.visible;
  }

  setVisible(visible) {
    this.label.setVisible(visible);
  }

  updatePlacement(pos3D, anchor) {
    if (anchor) this.#setAnchor(anchor);
    this.label.pos3D = pos3D;
    this.label.update();
  }

  setSelected(value, faded) {
    if (value) {
      this.label.container.classList.add("hud-level-selected");
      this.backBtn.show();
    } else {
      this.label.container.classList.remove("hud-level-selected");
      this.backBtn.hide();
    }

    if (faded && !value) {
      this.label.container.classList.add("hud-level-fade");
      this.label.textDiv.classList.add("hud-level-text-fade");
    } else {
      this.label.container.classList.remove("hud-level-fade");
      this.label.textDiv.classList.remove("hud-level-text-fade");
    }

    this.isSelected = value;
  }

  #makeLabel(hud) {
    // In the case of these elements that require advanced placement, we don't want a valid position where
    // the label could flash visible. Let's wait until we know the right one.
    const label = new HUDLabel(hud.viewer, INVALID_POS3D, this.level.id, this.level.id, { noDefaultStyle: true });
    label.setVisible(false);
    label.container.classList.add('hud-level');
    label.setText(this.name);
    this.label = label;

    this.backBtn = new LayerBackButton(hud.twin.facetsManager, hud.viewer.container.ownerDocument, FacetTypes.levels, this.level.id);
    this.backBtn.attachTo(this);

    return label;
  }

  #setAnchor(anchor) {
    this.label.labelAnchor = anchor;
  }
}